import * as React from 'react';
import { TileLayout } from '@progress/kendo-react-layout';


const TileLayoutComponent = props => {
  const [tiles, SetTiles] = React.useState([])


  React.useEffect(() => {
    const updatedTiles = [];
    for (const item of props.tiles) {
      if (tiles && tiles.filter(x => x.id !== item.id).length > 0) {
        if (props.selectedTile && props.selectedTile.filter(x => x.id === item.id).length > 0)
          updatedTiles.push(props.selectedTile.filter(x => x.id === item.id)[0])
        else if (item.id < 5)
          updatedTiles.push(item)
      } else {
        if (props.selectedTile && props.selectedTile.filter(x => x.id === item.id).length > 0)
          updatedTiles.push(props.selectedTile.filter(x => x.id === item.id)[0])
      }
    }
    SetTiles(updatedTiles);
  }, []);


  const {
    dir
  } = props;
  // rowHeight={230}
  return <TileLayout className='tile-block' dir={dir} columns={2}  gap={{
    rows: 10,
    columns: 10
  }} items={props.selectedTile.length > 0 ? props.selectedTile : props.tiles} />

};
export default TileLayoutComponent;